import ServicePageTemplate from "../../components/ServicePageTemplate";
import { IMAGES } from "../../lib/assets";

// NOTE TO MIGUEL / CONTENT EDITOR:
// Replace everything wrapped in [SQUARE BRACKETS] with final copy. Keep
// keywords natural — write for humans first.

export default function InteriorFinishingPage() {
  return (
    <ServicePageTemplate
      seo={{
        slug: "interior-finishing",
        // SEO TITLE — primary keywords: interior finishing, GIB stopping,
        // interior painting Auckland
        title:
          "Interior Finishing — GIB Stopping, Plastering & Painting Auckland | Trust Flooring & Interiors",
        // META DESCRIPTION — 150–160 characters
        description:
          "Interior finishing specialists across Auckland, Christchurch and New Zealand — GIB fixing, interior plastering, wall preparation and painting for residential and commercial construction.",
        canonical: "https://trustflooring.co.nz/services/interior-finishing",
      }}
      eyebrow="Services — Interior Finishing"
      h1="Interior finishing from lining through to paint."
      // [INSERT HERO IMAGE — interior finishing / plastered wall / painted
      // interior photograph]
      heroImage={IMAGES.interiorFinishing}
      // [INSERT IMAGE ALT TEXT — e.g. "interior plastering and painting on a
      // residential fit-out in Auckland"]
      heroAlt="Interior plastering and painting on a residential fit-out, Auckland"
      intro={[
        // [INSERT INTRO PARAGRAPH 1 — keywords: interior finishing Auckland,
        // GIB stopping, interior painting Christchurch]
        "Trust Flooring & Interiors provides complete interior finishing for residential and commercial projects across Auckland, Christchurch and New Zealand. From GIB fixing and stopping through to wall preparation, interior plastering and final paint, we take the interior from closed-in to handover-ready.",
        // [INSERT INTRO PARAGRAPH 2 — secondary keywords: Level 5 finish, paint
        // finish quality, architectural interiors]
        "Our finishers work to architectural tolerances — consistent corners, flat planes and paint finishes that hold up under raking light. [Replace this with a sentence specific to your finishing standards, Level 5 work, or the types of projects you take on.]",
      ]}
      offerings={{
        heading: "Interior finishing services we offer.",
        items: [
          "GIB fixing",
          "Interior plastering",
          "Interior painting",
          "Wall preparation and finishing",
        ],
      }}
      why={{
        heading: "Why specify Trust Flooring for finishing.",
        // [INSERT WHY PARAGRAPH]
        paragraph:
          "One trade partner for lining, plastering and painting means fewer handovers, fewer defects and a single point of accountability. We coordinate sequencing with your site manager so the interior trades move through the programme without stalling the build.",
        points: [
          "Single-team handover from GIB to final paint",
          "Consistent plaster and paint finish standards",
          "Familiar with residential and commercial build programmes",
          "Clean site conduct and protected finished surfaces",
        ],
      }}
    />
  );
}
